export default "__VITE_ASSET__1GlKx02W__";